import React from 'react';
import Header from './Header';
import './Layout.css';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <>
      <div className="layoutHeaderContainer">
        <Header />
      </div>

      <main className="layoutMainContent">
        <Outlet />
      </main>
    </>
  );
};

export default Layout;